import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import {
  postMedicamentos,
  setActiveStep
} from "../../../actions/empadronamiento/Empadronamiento";
import {
  STEPPER_EMPADRONAMIENTO
} from "../../../utils/constants";
import { EmpadronamientoCard } from "../UI/EmpadronamientoCard";
import { EmpadronamientoAddMedicamento } from "./EmpadronamientoAddMedicamento";
import { EmpadronamientoMedicamento } from "./EmpadronamientoMedicamento";
//import { Redirect } from "react-router-dom";

export const EmpadronamientoMedicamentos = (props) => {
  const dispatch = useDispatch();

  const { medicamentos = [], solicitudSeleccionada = {} } = useSelector(
    (state) => state.empadronamiento
  );

  const avanzarPantalla = () => {
    dispatch(setActiveStep(STEPPER_EMPADRONAMIENTO.CONFIRMACION));
  };

  console.log("medicamentos", medicamentos);

  const onClickSiguienteHandler = () => {
    const medicamentosFormateados = medicamentos.map((medicamento) => {
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        idMedicamento: medicamento.idMedicamento,
        cantidad: medicamento.cantidad,
        dosis: medicamento.dosis,
        posologia: medicamento.posologia,
        surge: medicamento.surge,
        idConvenioSC: medicamento.idConvenioSC,
        idTipoEmpadronamiento: solicitudSeleccionada.idTipoEmpadronamiento,
      };
    });

    dispatch(postMedicamentos({ medicamentos: medicamentosFormateados }, avanzarPantalla));

  };

  return (
    <EmpadronamientoCard width={"75%"}>
      <EmpadronamientoAddMedicamento disabledEnGestionar={false}/>
      {medicamentos.map((medicamento, index) => {
        return (
          <EmpadronamientoMedicamento
            key={index}
            medicamento={medicamento}
            idTipoEmpadronamiento={solicitudSeleccionada.idTipoEmpadronamiento}
          />
        );
      })}
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="secondary"
          style={{ marginRight: "3rem" }}
          onClick={() => {
            dispatch(setActiveStep(STEPPER_EMPADRONAMIENTO.DOCUMENTACION));
          }}
        >
          Anterior
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onClickSiguienteHandler}
        >
          Siguiente
        </Button>
      </div>
      {/*redirect && (
        <Redirect
          to={{
            pathname: "/autorizaciones",
          }}
        />
        )*/}
    </EmpadronamientoCard>
  );
};